import { Button } from "@/components/ui/button";

interface ApproveButtonProps {
  /** The main button's label: "Approve and publish" or "Publish changes". */
  label: string;
  disabled: boolean;
  busy: boolean;
  onApprove: () => void;
}

/** The page's one main button. While a write is on its way it is off and says what is happening. */
export function ApproveButton({
  label,
  disabled,
  busy,
  onApprove,
}: ApproveButtonProps) {
  return (
    <Button type="button" disabled={disabled || busy} onClick={onApprove}>
      {busy ? "Approving…" : label}
    </Button>
  );
}
